//# sourceMappingURL=keyboard.mjs.map
/// <reference types="./keyboard.d.mts" />
import * as $event from "../../../../redraw/redraw/event.mjs";
import * as $unsafe from "../../../../redraw/redraw/internal/unsafe.mjs";
import * as $ui from "../../../redraw/dom/event/ui.mjs";
import {
  altKey as alt_key,
  code,
  ctrlKey as ctrl_key,
  key,
  locale,
  metaKey as meta_key,
  location,
  repeat,
  shiftKey as shift_key,
  getModifierState as get_modifier_state,
} from "./events.ffi.mjs";

export {
  alt_key,
  code,
  ctrl_key,
  get_modifier_state,
  key,
  locale,
  location,
  meta_key,
  repeat,
  shift_key,
};

/**
 * `KeyboardEvent` inherits `UIEvent`.
 */
export const as_ui_event = $unsafe.coerce;

/**
 * `KeyboardEvent` inherits `Event`.
 */
export const as_event = $unsafe.coerce;
